module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4",
      "offset-sm": "4"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("New Password")])]), _vm._v(" "), _c('v-card-text', [_vm._v("\n            Set a new password for " + _vm._s(_vm.username) + ":\n            "), _c('v-text-field', {
    attrs: {
      "name": "input",
      "label": "New Password",
      "required": "",
      "rules": [_vm.passwordRule, _vm.passwordsEqual],
      "type": "password",
      "counter": "",
      "min": _vm.passwordLength
    },
    model: {
      value: (_vm.passwordReset1),
      callback: function($$v) {
        _vm.passwordReset1 = $$v
      },
      expression: "passwordReset1"
    }
  }, [_vm._v("\n            >")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "input",
      "label": "Verify New Password",
      "required": "",
      "rules": [_vm.passwordRule, _vm.passwordsEqual],
      "type": "password",
      "counter": "",
      "min": _vm.passwordLength
    },
    model: {
      value: (_vm.passwordReset2),
      callback: function($$v) {
        _vm.passwordReset2 = $$v
      },
      expression: "passwordReset2"
    }
  }, [_vm._v("\n            >")]), _vm._v("\n            " + _vm._s(_vm.username) + "\n          ")], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reset.apply(null, arguments)
      }
    }
  }, [_vm._v("Set Password")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('error-snackbar', {
    model: {
      value: (_vm.errorText),
      callback: function($$v) {
        _vm.errorText = $$v
      },
      expression: "errorText"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-404d5688","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@sdgsystems/vue-common/components/PasswordResetForm.vue
// module id = 425
// module chunks = 1